import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fit-cc-lib',
    template: `
    <p>
      fit-common-components-lib works!
    </p>
  `,
    styles: [],
    standalone: false
})
export class FitCommonComponentsLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
